import { httpClient } from "@/main";

export async function validateByProduct(code, product) {
  return await httpClient.post("/checkout/couponcode/validatebyproduct", {
    couponCode: code,
    product
  });
}
